import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SectionFreeMockComponent } from "../../../User/Components/dashboard/section-free-mock/section-free-mock.component";
import { SectionStudyMaterialsComponent } from "../../../User/Components/dashboard/section-study-materials/section-study-materials.component";

@Component({
  selector: 'app-my-study',
  imports: [
    CommonModule,
    SectionFreeMockComponent,
    SectionStudyMaterialsComponent
],
  templateUrl: './my-study.component.html',
  styleUrl: './my-study.component.css'
})
export class MyStudyComponent {

}
